import { render, staticRenderFns } from "./PassWordModify.vue?vue&type=template&id=7215d7bd&scoped=true"
import script from "./PassWordModify.vue?vue&type=script&lang=js"
export * from "./PassWordModify.vue?vue&type=script&lang=js"
import style0 from "./PassWordModify.vue?vue&type=style&index=0&id=7215d7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215d7bd",
  null
  
)

export default component.exports